// @ts-nocheck
import React, { useCallback } from 'react';
import { compose } from '@/utils';

import { DataTable, TableSkeletonRows } from '@/components';

import { useSalesPeopleContext } from './SalesPeopleProvider';

import { ActionMenuList, useSalesPeopleTableColumns } from './components';

import withDialogActions from '@/containers/Dialog/withDialogActions';
import withAlertActions from '@/containers/Alert/withAlertActions';
import styled from 'styled-components';

/**
 * Currencies table.
 */
function SalesPeopleTable({
  // #ownProps
  tableProps,

  // #withDialog.
  openDialog,

  // #withAlertActions
  openAlert,
}) {
  const { salespoeple, isSalespoepleLoading } = useSalesPeopleContext();

  // Table columns.
  const columns = useSalesPeopleTableColumns();

  // Handle Edit Currency.
  const handleEditSalesPeople = useCallback(
    (salesPerson) => {
       console.log("Edit clicked", salesPerson);
      openDialog('sales-people-form', {
        action: 'edit',
        salesPerson: salesPerson,
      });
    },
    [openDialog],
  );

  // Handle delete currency.
  const handleDeleteSalesPeople = ({ id }) => {
    console.log('delete sales people with id', id);
    // openAlert('salesperson-delete', {id});
    openAlert('salesperson-delete', { currency_code: id });
  };

  return (
    <SalespeopleDataTable
      columns={columns}
      data={salespoeple}
      loading={isSalespoepleLoading}
      progressBarLoading={isSalespoepleLoading}
      TableLoadingRenderer={TableSkeletonRows}
      ContextMenu={ActionMenuList}
      noInitialFetch={true}
      payload={{
        onDeleteSalespeople: handleDeleteSalesPeople,
        onEditSalesPeople: handleEditSalesPeople,
      }}
      rowContextMenu={ActionMenuList}
      {...tableProps}
    />
  );
}

export default compose(
  withDialogActions,
  withAlertActions,
)(SalesPeopleTable);

const SalespeopleDataTable = styled(DataTable)`
  .table .th,
  .table .td {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
  }
`;
